import {
  DateInput,
  maxLength,
  minLength,
  required,
  useDataProvider,
} from "react-admin";
import { useQuery } from "react-query";
import currentDate from "../../../utils/currentDate";

const validateDate = [required(), minLength(10), maxLength(10)];

const DateInputCheckLimit = () => {
  const dataProvider = useDataProvider();

  const { data, isLoading, error } = useQuery(
    ["settings/sale-date-change-limit", "getListNoParams"],
    () => dataProvider.getListNoParams("settings/sale-date-change-limit")
  );

  return (
    <DateInput
      variant="outlined"
      source="date"
      label="mine.label.date"
      fullWidth
      validate={validateDate}
      defaultValue={currentDate()}
      disabled={data == 0 ? true : false}
    />
  );
};

export default DateInputCheckLimit;
